import { styled } from '@mui/system';

import { AgColor } from '../../stories/Styles/AgColor';

export const Notification = styled('div')`
  padding: 8px 16px;
  border-radius: 8px;

  &.customError {
    margin: 16px 0 0 16px;
    display: flex;
    gap: 16px;
    width: 100%;
    border: 1px solid ${AgColor.errorHighlight};
    background-color: ${AgColor.errorLight};
  }

  &.error {
    border: 1px solid ${AgColor.errorHighlight};
    background-color: ${AgColor.errorLight};
  }

  &.info {
    border: 1px solid ${AgColor.blueMain};
    background-color: ${AgColor.blueLight};
  }

  &.success {
    border: 1px solid ${AgColor.greenMain};
    background-color: ${AgColor.greenLight};
  }
`;
